// Maps country names (as they appear in ScoreBat competition names) to flag emojis.
// Regional indicator emojis are derived from ISO 3166-1 alpha-2 codes.

const toFlag = (code) =>
  code
    .toUpperCase()
    .split("")
    .map((c) => String.fromCodePoint(0x1f1e6 + c.charCodeAt(0) - 65))
    .join("");

const COUNTRY_FLAGS = {
  // Europe
  ENGLAND: "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F",
  SCOTLAND: "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F",
  WALES: "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F",
  FRANCE: toFlag("FR"),
  SPAIN: toFlag("ES"),
  GERMANY: toFlag("DE"),
  ITALY: toFlag("IT"),
  PORTUGAL: toFlag("PT"),
  NETHERLANDS: toFlag("NL"),
  TURKEY: toFlag("TR"),
  GREECE: toFlag("GR"),
  AUSTRIA: toFlag("AT"),
  DENMARK: toFlag("DK"),
  FINLAND: toFlag("FI"),
  HUNGARY: toFlag("HU"),
  NORWAY: toFlag("NO"),
  SWEDEN: toFlag("SE"),
  SWITZERLAND: toFlag("CH"),
  BELGIUM: toFlag("BE"),
  POLAND: toFlag("PL"),
  CROATIA: toFlag("HR"),
  UKRAINE: toFlag("UA"),
  RUSSIA: toFlag("RU"),
  SERBIA: toFlag("RS"),
  ROMANIA: toFlag("RO"),
  BULGARIA: toFlag("BG"),
  BELARUS: toFlag("BY"),
  SLOVENIA: toFlag("SI"),
  "NORTH MACEDONIA": toFlag("MK"),
  "CZECH REPUBLIC": toFlag("CZ"),
  CZECHIA: toFlag("CZ"),
  SLOVAKIA: toFlag("SK"),
  ALBANIA: toFlag("AL"),
  MOLDOVA: toFlag("MD"),
  IRELAND: toFlag("IE"),
  "NORTHERN IRELAND": toFlag("GB"),
  KOSOVO: toFlag("XK"),
  LUXEMBOURG: toFlag("LU"),
  ICELAND: toFlag("IS"),
  MALTA: toFlag("MT"),
  ANDORRA: toFlag("AD"),
  LIECHTENSTEIN: toFlag("LI"),
  "FAROE ISLANDS": toFlag("FO"),
  MONTENEGRO: toFlag("ME"),
  GEORGIA: toFlag("GE"),
  ARMENIA: toFlag("AM"),
  AZERBAIJAN: toFlag("AZ"),
  ESTONIA: toFlag("EE"),
  LATVIA: toFlag("LV"),
  LITHUANIA: toFlag("LT"),
  CYPRUS: toFlag("CY"),
  KAZAKHSTAN: toFlag("KZ"),
  UZBEKISTAN: toFlag("UZ"),
  "BOSNIA & HERZEGOVINA": toFlag("BA"),
  BOSNIA: toFlag("BA"),

  // Americas
  ARGENTINA: toFlag("AR"),
  BRAZIL: toFlag("BR"),
  BRASIL: toFlag("BR"),
  CHILE: toFlag("CL"),
  COLOMBIA: toFlag("CO"),
  ECUADOR: toFlag("EC"),
  VENEZUELA: toFlag("VE"),
  BOLIVIA: toFlag("BO"),
  PERU: toFlag("PE"),
  PARAGUAY: toFlag("PY"),
  URUGUAY: toFlag("UY"),
  USA: toFlag("US"),
  CANADA: toFlag("CA"),
  MEXICO: toFlag("MX"),
  "COSTA RICA": toFlag("CR"),

  // Africa
  MOROCCO: toFlag("MA"),
  NIGERIA: toFlag("NG"),
  "SOUTH AFRICA": toFlag("ZA"),
  EGYPT: toFlag("EG"),
  SENEGAL: toFlag("SN"),
  GHANA: toFlag("GH"),
  IVORY: toFlag("CI"),
  "IVORY COAST": toFlag("CI"),
  CAMEROON: toFlag("CM"),
  ALGERIA: toFlag("DZ"),
  TUNISIA: toFlag("TN"),

  // Asia / Middle East
  JAPAN: toFlag("JP"),
  "SOUTH KOREA": toFlag("KR"),
  KOREA: toFlag("KR"),
  CHINA: toFlag("CN"),
  IRAN: toFlag("IR"),
  "SAUDI ARABIA": toFlag("SA"),
  QATAR: toFlag("QA"),
  UAE: toFlag("AE"),
  ISRAEL: toFlag("IL"),
  AUSTRALIA: toFlag("AU"),

  // International / Confederations (no single country flag)
  UEFA: "🏆",
  FIFA: "🌍",
  WORLD: "🌍",
  EUROPE: "🏆",
  CONCACAF: "🏆",
  CONMEBOL: "🏆",
  CAF: "🏆",
  AFC: "🏆",
};

export const lookupFlag = (name) => COUNTRY_FLAGS[name.trim().toUpperCase()] || null;

/**
 * Returns the flag emoji for a given ScoreBat competition name.
 * Competition names follow the format "COUNTRY: League Name".
 */
export function getCompetitionFlag(competitionName) {
  if (!competitionName) return null;
  const country = competitionName.split(":")[0].trim().toUpperCase();
  return COUNTRY_FLAGS[country] || null;
}

/**
 * Returns an array of 1 or 2 flag emojis for a match.
 * If both team names in the title match known countries, returns [flagA, flagB].
 * Otherwise falls back to the single competition flag.
 *
 * Match titles follow the format "Team A - Team B".
 */
export function getMatchFlags(title, competitionName) {
  if (title) {
    const parts = title.split(" - ");
    if (parts.length === 2) {
      const flagA = lookupFlag(parts[0]);
      const flagB = lookupFlag(parts[1]);
      if (flagA && flagB) return [flagA, flagB];
    }
  }
  const compFlag = getCompetitionFlag(competitionName);
  return compFlag ? [compFlag] : [];
}
